<!-- FormatStep.vue -->
<template>
    <div class="step-wrap">
        <div class="step-header">
            <h1 class="step-h1">Frame the shot</h1>
            <p class="step-lead">Pick how your scene is captured.</p>
        </div>
        <div class="format-grid-wrap hide-scrollbar">
            <div class="format-grid">
                <button
                    v-for="f in FORMATS"
                    :key="f.id"
                    class="format-card"
                    :class="{ 'is-selected': format === f.id }"
                    @click="$emit('update:format', f.id)"
                >
                    <span v-if="f.popular" class="popular-badge">Popular</span>
                    <div class="format-icon-wrap">
                        <component :is="formatIconMap[f.id]" class="format-icon" />
                    </div>
                    <p class="format-label">{{ f.name }}</p>
                    <p class="format-sub">{{ f.subtitle }}</p>
                </button>
            </div>
        </div>
        <div class="step-footer">
            <button class="cta-btn" @click="$emit('next')">Set the scene</button>
        </div>
    </div>
</template>

<script setup>
import { h } from 'vue'
import { Smartphone, Layers, Globe } from 'lucide-vue-next'

defineProps({ format: String, selectedCast: Array, customCast: Array })
defineEmits(['update:format', 'next'])

const Monitor = {
    render: () => h('svg', { viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', stroke: 'currentColor', 'stroke-width': '1.75', 'stroke-linecap': 'round', 'stroke-linejoin': 'round' }, [
        h('rect', { width: '20', height: '14', x: '2', y: '3', rx: '2' }),
        h('line', { x1: '8', x2: '16', y1: '21', y2: '21' }),
        h('line', { x1: '12', x2: '12', y1: '17', y2: '21' })
    ])
}

const FORMATS = [
    { id: 'Standard',      name: 'Standard',      subtitle: 'Cinematic · side view',   popular: true  },
    { id: 'VR',            name: 'VR',            subtitle: 'First-person · headset',   popular: false },
    { id: 'Vertical',      name: 'Vertical',      subtitle: 'Phone-shaped · shorts',    popular: false },
    { id: 'Mixed Reality', name: 'Mixed Reality', subtitle: 'Immersive spatial',         popular: false },
]

const formatIconMap = { 'Standard': Monitor, 'VR': Globe, 'Vertical': Smartphone, 'Mixed Reality': Layers }
</script>

<style scoped>
.step-wrap { display:flex; flex-direction:column; height:100%; padding:12px 16px 0; }
.step-header { margin-bottom:28px; margin-top:8px; }
.step-h1 { font-size:32px; font-weight:800; color:white; margin-bottom:6px; }
.step-lead { color:rgba(255,255,255,0.7); font-size:15px; }

.format-grid-wrap { flex:1; overflow-y:auto; padding:6px; }
.format-grid { display:grid; grid-template-columns:1fr 1fr; gap:12px; }

.format-card {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 28px 16px 24px;
    border-radius: 16px;
    background: rgba(255,255,255,0.04);
    border: 1px solid rgba(255,255,255,0.08);
    cursor: pointer;
    transition: background 0.2s, border-color 0.2s, box-shadow 0.2s;
    color: white;
    font-family: inherit;
    text-align: center;
}
.format-card:hover { background:rgba(255,255,255,0.07); border-color:rgba(255,255,255,0.18); }
.format-card:active { transform:scale(0.97); }
.format-card.is-selected {
    background: rgba(0, 82, 204, 0.18);
    border-color: rgba(77, 148, 255, 0.9);
    box-shadow: 0 0 0 3px #0A0A0F, 0 0 0 5px rgba(77, 148, 255, 0.45);
}

.popular-badge {
    position: absolute;
    top: 12px;
    right: 12px;
    font-size: 11px;
    font-weight: 700;
    color: #fbbf24;
    background: rgba(251, 191, 36, 0.15);
    border: 1px solid rgba(251, 191, 36, 0.6);
    border-radius: 9999px;
    padding: 3px 9px;
    line-height: 1.4;
}

.format-icon-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
    color: rgba(255,255,255,0.65);
}
.format-card.is-selected .format-icon-wrap {
    color: #60a5fa;
}
.format-icon { width:26px; height:26px; }

.format-label { font-size:17px; font-weight:700; color:white; margin:0; line-height:1.2; }
.format-sub { font-size:12px; color:rgba(255,255,255,0.4); margin:0; line-height:1.4; }
.format-card.is-selected .format-sub { color:rgba(255,255,255,0.55); }

.step-footer { padding:14px 0 4px; flex-shrink:0; }
.cta-btn { width:100%; background:#0052CC; color:white; font-weight:700; font-size:17px; padding:14px 0; border-radius:16px; border:none; cursor:pointer; }
</style>
